import { getLambdaRoute } from "@src/utils/getLambdaRoute"
import { ICtfTemplateProps } from "@src/api/ctf-template"

export const updateCTFTemplate = async ({
  contentfulId,
  incrementDownload,
  incrementLike,
  rating,
}: ICtfTemplateProps) => {
  const data: ICtfTemplateProps = {
    contentfulId: contentfulId,
    incrementDownload: incrementDownload,
    incrementLike: incrementLike,
    rating: rating,
  }

  const configObj = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }

  try {
    return await fetch(getLambdaRoute(`/ctf-template`), configObj)
  } catch (error) {
    return console.log(error)
  }
}
